export const USER_ROLES = {
    ADMINISTRATOR: "administrator",
    SHOPMANAGER: "shop_manager",
    CUSTOMER: "customer"
}